import { useId, useRef } from "react";
import { Box, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import CalendarMonth from "@mui/icons-material/CalendarMonth";
import { timeHelper } from "./time";

export function EasternDateTimeField({
	label,
	value,
	onChange
}: {
	label: string;
	value: string;
	onChange: (value: string) => void;
}) {
	const picker = useRef<HTMLInputElement>(null);
	const helperId = useId();
	const parts = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}:\d{2}:\d{2})$/.exec(value);
	const localValue = parts ? `${parts[3]}-${parts[1]}-${parts[2]}T${parts[4]}` : "";
	return (
		<Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1.5 }}>
			<TextField
				label={label}
				required
				placeholder="MM/DD/YYYY HH:mm:ss"
				value={value}
				onChange={(event) => onChange(event.target.value)}
				sx={{ width: 335, maxWidth: "100%" }}
				slotProps={{
					htmlInput: { "aria-describedby": helperId },
					input: {
						endAdornment: (
							<InputAdornment position="end">
								<input
									ref={picker}
									type="datetime-local"
									step={1}
									value={localValue}
									tabIndex={-1}
									aria-hidden
									style={{
										position: "absolute",
										opacity: 0,
										width: 1,
										height: 1,
										pointerEvents: "none"
									}}
									onChange={(event) => {
										const selected = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}:\d{2})(?::(\d{2}))?$/.exec(
											event.target.value
										);
										if (selected)
											onChange(
												`${selected[2]}/${selected[3]}/${selected[1]} ${selected[4]}:${selected[5] ?? "00"}`
											);
									}}
								/>
								<IconButton
									aria-label={
										label.startsWith("Start") ? "Choose start schedule" : "Choose end schedule"
									}
									onClick={() => picker.current?.showPicker()}
								>
									<CalendarMonth />
								</IconButton>
							</InputAdornment>
						)
					}
				}}
			/>
			<Typography
				id={helperId}
				variant="body2"
				color="text.secondary"
			>
				{timeHelper(value)}
			</Typography>
		</Box>
	);
}
